module.exports = __webpack_public_path__ + "static/es-11fad61b4f97c35e862d7bb07f3879d8.jpg";